// src/config/features.js
// Feature flags - kontrola włączania/wyłączania funkcji

export const FEATURES = {
  // Dżban Roku - tylko lokalnie (wymaga REACT_APP_ENABLE_DZBAN=true w .env.local)
  DZBAN_ROKU: process.env.REACT_APP_ENABLE_DZBAN === 'true'
};